export const cleanQueryValue = (value?: string | null): string => {
  if (!value || value === "undefined" || value === "null") {
    return "";
  }

  return value.replace(/"/g, "").trim();
};

export const formatAmount = (value: any) => {
  const num = Number(value);
  return Number.isInteger(num) ? num : num.toFixed(2);
};
